import { DCRecord } from "@/@types/lib/dataController";
import api from "../lib/api";

export interface IKatoviService {
  partiallyUpdateKat: (objektId: number, katId: number, data: any) => Promise<any>;
}

const katoviService: IKatoviService = {
  partiallyUpdateKat
};

function partiallyUpdateKat(objektId: number, katId: number, data: any) {
  const apiInstance = new api();
  const url = `operations/objekti/${objektId}/katovi/${katId}`;

  return apiInstance.Call(url, "patch", data);
}

export default katoviService;